import { Button, SvgIconTypeMap, Tooltip } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import Save from '@mui/icons-material/Save';
import SwapHoriz from '@mui/icons-material/SwapHoriz';
import AddAPhoto from '@mui/icons-material/Photo';
import FileDownload from '@mui/icons-material/FileDownload';
import FileUpload from '@mui/icons-material/FileUpload';
import SelectAll from '@mui/icons-material/SelectAll';

type TypeNames = 'add' | 'edit' | 'delete' | 'save' | 'replace' | 'image' | 'export' | 'import' | 'selectAll';
const TYPE_ADD: TypeNames = 'add';
const TYPE_EDIT: TypeNames = 'edit';
const TYPE_DELETE: TypeNames = 'delete';
const TYPE_SAVE: TypeNames = 'save';
const TYPE_REPLACE: TypeNames = 'replace';
const TYPE_IMAGE: TypeNames = 'image';
const TYPE_EXPORT: TypeNames = 'export';
const TYPE_IMPORT: TypeNames = 'import';
const TYPE_SELECT_ALL: TypeNames = 'selectAll';

type Props = {
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  type: TypeNames;
  icon?: ReactElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [rest: string]: any;
};

type ACTION_BUTTON_TYPE = {
  tooltip: string;
  icon: OverridableComponent<SvgIconTypeMap>;
};

type ACTION_BUTTON_TYPE_MAP_TYPE = {
  [key: string]: ACTION_BUTTON_TYPE;
};

const TYPE_MAP: ACTION_BUTTON_TYPE_MAP_TYPE = {
  [TYPE_ADD]: {
    tooltip: 'Add',
    icon: AddCircleIcon,
  },
  [TYPE_EDIT]: {
    tooltip: 'Edit',
    icon: Edit,
  },
  [TYPE_DELETE]: {
    tooltip: 'Delete',
    icon: Delete,
  },
  [TYPE_SAVE]: {
    tooltip: 'Save',
    icon: Save,
  },
  [TYPE_REPLACE]: {
    tooltip: 'Replace',
    icon: SwapHoriz,
  },
  [TYPE_IMAGE]: {
    tooltip: 'Image',
    icon: AddAPhoto,
  },
  [TYPE_EXPORT]: {
    tooltip: 'Export',
    icon: FileDownload,
  },
  [TYPE_IMPORT]: {
    tooltip: 'Import',
    icon: FileUpload,
  },
  [TYPE_SELECT_ALL]: {
    tooltip: 'Select All',
    icon: SelectAll,
  },
};

const ActionButton = (props: PropsWithChildren<Props>) => {
  const { type, onClick, children, icon, inRow = false, iconSize = 'small', disabled = false, ...rest } = props;
  const IconComponent = TYPE_MAP[type].icon;
  const ButtonComponent = (
    <Button
      variant="text"
      onClick={onClick}
      disabled={disabled}
      size="small"
      sx={{
        display: 'flex',
        flexDirection: inRow ? 'row-reverse' : 'column',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: '0.9rem',
        gap: inRow ? '3px' : 0,
      }}
      {...rest}
    >
      <span style={{ color: '#555' }}>{children}</span>
      {icon || <IconComponent fontSize={iconSize} sx={!inRow ? { marginTop: '3px' } : {}} />}
    </Button>
  );
  if (disabled) {
    return ButtonComponent;
  }
  return <Tooltip title={TYPE_MAP[type].tooltip}>{ButtonComponent}</Tooltip>;
};

export default ActionButton;
